const accessLists = {
  header: {
    toolbar: {
      blackList: 'Чорний список',
      whiteList: 'Білий список',
    },
    buttons: {
      addNewRecord: 'Додати новий запис'
    }
  },
  accessLists: 'Списки доступу',
  showing: 'Показано',
  accessListsOf: 'списки доступу',
  noAccessListsFound: 'Списки доступу не знайдено',
  modal: {
    category: 'Категорія',
    enterCategory: 'Введіть категорію',
    value: 'Значення',
    enterValue: 'Введіть значення',
    inputValue: 'Будь ласка, введіть значення',
    inputCategory: 'Будь ласка, введіть категорію',
    list_type: 'Тип списку',
    enterListType: 'Будь ласка, введіть тип списку',
    description: 'Опис',
    enterDescription: 'Будь ласка, введіть опис',
    blackList: 'Чорний список',
    whiteList: 'Білий Список',
  },
  allCategories: 'Усі категорії',
  successAdded: 'Додано нове значення'
};

export default accessLists;
